<template>
	<div class="cou_fig">
		<div class="cou_cont">
			<div class="crumbs">当前位置：<a href="/" style="color: #999999;text-decoration: none">论坛首页</a>-专家文章</div>
			<div class="cou_list">
				<div class="person">
					<div class="message">
						<router-link class="title" :to="{path:'/council_details',query:{id:zj.id,u:zj.updateTime,exp_id:zj.id}}" >
							<div class="photo">
								<img :src="zj.avator" alt="" style="width: 67px;height: 67px;border-radius: 50%;object-fit: cover;">
							</div>
							<div class="info">
								<div class="name">{{zj.name}}</div>
								<div class="text">{{zj.title}}</div>
							</div>
						</router-link>
						<div class="texts">
							{{zj.background}}
						</div>
					</div>
					<div class="section_1">
						<div class="title">
							<div class="left"><img src="../../assets/wbanner_53.png" alt="">作者其他文章</div>
						<!-- 	<div class="right"><img src="../../assets/wbanner_55.png" alt=""></div> -->
						</div>
						<div class="sec1_cont">
							<div class="sec1">
								<div class="list" v-for="(item,index) in sec1">
									<img src="../../assets/wbanner_56.png" alt="">
									<router-link style="color: #666666;text-decoration: none;" :to="{path:'/council_figure',query:{id:item.id,c:item.createTime,u:item.updateTime,exp:item.expertID}}" class="text-de">{{item.title}}</router-link>
								</div>
							</div>
						</div>
					</div>
					<div class="section_1">
						<div class="title">
							<div class="left"><img src="../../assets/wbanner_53.png" alt="">推荐文章</div>
						</div>
						<div class="sec1_cont">
							<div class="sec1">
								<div class="list" v-for="(item,index) in others">
									<img src="../../assets/wbanner_56.png" alt="">
									<router-link style="color: #666666;text-decoration: none;" :to="{path:'/council_figure',query:{id:item.id,c:item.createTime,u:item.expertsTime,exp:item.expertID}}" class="text-de">{{item.title}}</router-link>
								</div>
							</div>
						</div>
					</div>
					
				</div>
				<div class="article_bg">
					<div class="article">
						<div class="title">{{zj.name}}：{{wenzhang.title}} </div>
						<div class="time">{{wenzhang.createTime}}</div>
						<div class="essays">
							<div class="word" v-html="wenzhang.content"></div>
						
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { encrypt,decrypt, generatekey } from "@/plugins/des2.js"
	import qs from 'qs'
	import {ArticleDetail,article,ArticleExpertList} from '../../api/api.js'
	export default {
		name: 'council_details',
		data() {
			return {
				zhuanjia:[],
				wenzhang:[],
				zj:{},
				exp_id:'',
				other:[],
				others:[],
				text_id:'',
				createTime:'',
				updateTime:'',
				sec1: [],
				sec2: [{
						sec2: "夏斌：如何围绕新征程做好政策研究"
					},
					{
						sec2: "夏斌：如何围绕新征程做好政策研究"
					},
					{
						sec2: "夏斌：如何围绕新征程做好政策研究"
					},
					{
						sec2: "夏斌：如何围绕新征程做好政策研究"
					},
					{
						sec2: "夏斌：如何围绕新征程做好政策研究"
					},
					{
						sec2: "夏斌：如何围绕新征程做好政策研究"
					},
					{
						sec2: "夏斌：如何围绕新征程做好政策研究"
					},
					{
						sec2: "夏斌：如何围绕新征程做好政策研究"
					},
					{
						sec2: "夏斌：如何围绕新征程做好政策研究"
					},
					{
						sec2: "夏斌：如何围绕新征程做好政策研究"
					},
				],
			}
		},
		mounted() {
			this.text_id=this.$route.query.id
			this.exp_id=this.$route.query.exp
			this.createTime=this.$route.query.c
			this.updateTime=this.$route.query.u
			console.log(this.exp_id)
			this.ArticleDetail()
			this.article()
			this.ArticleExpertList()
				this.ExpertAllList()
		},
		methods:{
			async ExpertAllList(){
				//加密
				
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				      	lastID:0
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await ExpertAllList(qs.stringify(requetp))	
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  	
				let azhuanjia=JSON.parse(dess).d.Data
				console.log('专家-----------------')
			
				for(var i=0;i<5;i++){
					this.zhuanjia.push(azhuanjia[i]) 
				}
				console.log(this.zhuanjia)
			},
			//获取某专家的文章
			async ArticleExpertList(){
				//加密
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				      	expertID:this.exp_id,
						page:1
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await ArticleExpertList(qs.stringify(requetp))
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  
				let sec1a=JSON.parse(dess).d.Data
				sec1a.forEach((e)=>{
					e.createTime=e.createTime.substr(0,10)
				})
				this.sec1=sec1a
				console.log(this.sec1)
				// this.zj=this.wenzhang.expertInfo
				// console.log(this.wenzhang)
			
			},
			async ArticleDetail(){
				//加密
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				      	entityID:this.text_id,
				      	createTime:this.createTime,
				      	updateTime:this.updateTime,
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await ArticleDetail(qs.stringify(requetp))
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  
				this.wenzhang=JSON.parse(dess).d
				this.zj=this.wenzhang.expertInfo
				// console.log(this.wenzhang)

			},
			async article(){
				//加密
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				      	articleType:100,
				      	type:100,
				      	page:1,
				      	expertList:[]
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await article(qs.stringify(requetp))
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  
				this.other=JSON.parse(dess).d.Data
				for(let i=0;i<10;i++){
					this.others.push(this.other[i])
				}
				console.log('推荐文章===============')
				console.log(this.others)
			},
			
		}
	}
</script>

<style>
	router-link{
		color: rgb(102, 102, 102);
		text-decoration: none;
	}
	.text-de{
		display: -webkit-box;
		-webkit-box-orient: vertical;
		line-clamp: 1;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap
	}
	.cou_fig .cou_cont {
		background-color: #fafafa;
		padding-bottom: 35px;
	}

	.cou_fig .crumbs {
		width: 1200px;
		margin: 0 auto;
		padding-top: 30px;
		font-size: 16px;
		color: #999999;
	}

	.cou_fig .cou_list {
		width: 1200px;
		margin: 0 auto;
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.cou_fig .cou_list .person {
		width: 33%;
	}

	.cou_fig .cou_list .person .message {
		background: #fff;
		border-radius: 10px;
		padding:20px 30px;
		margin-bottom: 35px;
	}

	.cou_fig .cou_list .person .message .title {
		display: flex;
		justify-content: space-between;
		color: rgb(102, 102, 102);
		    text-decoration: none;
		flex-wrap: wrap;
	}

	.cou_fig .cou_list .person .message .title .photo {
		width: 20%;
		height: 20%;
		margin-right: 10px;
		margin-top: 10px;
	}

	.cou_fig .cou_list .person .message .title .photo img {
		width: 100%;
		height: 100%;
	}

	.cou_fig .cou_list .person .message .title .info {
		width: 72%;
	}

	.cou_fig .cou_list .person .message .title .info .name {
		font-size: 24px;
		color: #333;
		margin-bottom: 5px;
	}

	.cou_fig .cou_list .person .message .title .info .text {
		font-size: 16px;
		color: #666666;
	}

	.cou_fig .cou_list .person .message .texts {
		font-size: 15px;
		color: #333333;
		line-height: 30px;
		margin-top: 20px;
	}

	.cou_fig .cou_list .person .section_1 {
		background-color: #fff;
		border-radius: 10px;
		padding: 15px 20px 20px 30px;
		margin-bottom: 35px;
	}

	.cou_fig .cou_list .person .section_1 .title {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		align-items: center;
		border-bottom: 1px solid #eeeeee;
		padding-bottom: 17px;
	}

	.cou_fig .cou_list .person .section_1 .title .left {
		font-size: 18px;
		color: #333;
		font-weight: bold;
	}

	.cou_fig .cou_list .person .section_1 .title .left img {
		margin-right: 5px;
		margin-top: -3px;
		vertical-align: middle;
	}

	.cou_fig .cou_list .person .section_1 .title .right {
		font-size: 14px;
		color: #999999;
	}

	.cou_fig .cou_list .person .section_1 .title .right img {
		margin-left: 5px;
		vertical-align: middle;
		margin-top: -3px;
	}

	.cou_fig .cou_list .person .section_1 .sec1 .list {
		margin-top: 14.5px;
		color: #666666;
		font-size: 16px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.cou_fig .cou_list .person .section_1 .sec1 img {
		vertical-align: middle;
		margin: -3px 10px 0 0;
	}

	.cou_fig .cou_list .person .section_1 .rest {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: 20px;
	}

	.cou_fig .cou_list .person .section_1 .rest_list {
		width: 17%;
	}

	.cou_fig .cou_list .person .section_1 .rest_list .photo img {
		width: 100%;
		height: 100%;
	}

	.cou_fig .cou_list .person .section_1 .rest_list .rest_text {
		font-size: 16px;
		color: #666666;
		margin-top: 5px;
		text-align: center;
	}

	.cou_fig .cou_list .article_bg {
		width: 63%;
		background-color: #fff;
		border-radius: 10px;
		height: 100%;
	}

	.cou_fig .cou_list .article {
		padding: 50px;
		height: 100%;
	}

	.cou_fig .cou_list .article .title {
		text-align: center;
		color: #333333;
		font-size: 18px;
		margin-bottom: 15px;
		font-weight: bold;
	}

	.cou_fig .cou_list .article .time {
		text-align: center;
		font-size: 14px;
		color: #999999;
		margin-bottom: 12px;
	}

	.cou_fig .cou_list .article .word {
		font-size: 16px;
		color: #333333;
		text-indent: 2em;
		line-height: 47.8px;
	}
	@media screen and (max-width: 1400px){
		.cou_fig .crumbs {
		    width: 900px;
		    padding-top: 20px;
		    font-size: 16px;
		}
		.cou_fig .cou_list {
		    width: 900px;
		    margin-top: 20px;
		}
		.cou_fig .cou_list .person {
		    width: 35%;
		}
		.cou_fig .cou_list .article {
		    padding: 30px;
		    height: 100%;
		}
		.cou_fig .cou_list .person .message {
		    background: #fff;
		    border-radius: 10px;
		    padding: 20px;
		    margin-bottom: 35px;
		}
	}
	@media screen and (max-width: 1000px){
		.cou_fig .crumbs {
		    width: 750px;
		    margin-top: 10px;
		    font-size: 16px;
		}
		.cou_fig .cou_list {
		    width: 750px;
		    margin-top: 10px;
		}
		.cou_fig .cou_list .person {
		    width: 100%;
		}
		.cou_fig .cou_list .article_bg {
		    width: 100%;
		}
		.cou_fig .cou_list .person .message .title .info {
		    width: 74%;
		}
		.cou_fig .cou_list .person .message .title{
			align-items: center;
		}
	}
	@media screen and (max-width: 768px){
		.cou_fig{
			margin-top: 60px;
		}
		.cou_fig .cou_list .person .message {
		    background: #fff;
		    border-radius: 10px;
		    padding: 10px;
		    margin-bottom: 10px;
		}
		.cou_fig .cou_list .person .message .title .info .name {
		    font-size: 18px;
		    color: #333;
		    margin-bottom: 5px;
		}
		.cou_fig .crumbs {
		    width: 98%;
		    margin-top: 10px;
		    font-size: 14px;
		}
		.cou_fig .cou_list {
		    width: 98%;
		}
		.cou_fig .cou_list .person .message .title .info {
		    width: 76%;
		}
		.cou_fig .cou_list .person .message .texts {
		    font-size: 14px;
		    color: #333333;
		    line-height: 30px;
		    margin-top: 10px;
		}
		.cou_fig .cou_list .person .section_1 {
		    background-color: #fff;
		    border-radius: 10px;
		    padding: 10px;
		    margin-bottom: 10px;
		}
		.cou_fig .cou_list .person .section_1 .title .left {
		    font-size: 16px;
		    color: #333;
		    font-weight: bold;
		}
		.cou_fig .cou_list .person .section_1 .sec1 .list {
		    margin-top: 12px;
		    color: #666666;
		    font-size: 14px;
		}
		.cou_fig .cou_list .person .section_1 .rest_list .rest_text {
		    font-size: 14px;
		    color: #666666;
		    margin-top: 5px;
		    text-align: center;
		}
		.cou_fig .cou_list .article {
		    padding: 10px;
		    height: 100%;
		}
		.cou_fig .cou_list .article .title {
		    font-size: 16px;
		    margin-bottom: 5px;
		}
		.cou_fig .cou_list .article .word {
		    font-size: 14px;
		    color: #333333;
		    text-indent: 2em;
		    line-height: 28px;
		}
		.cou_fig .cou_list .article .time {
		    text-align: center;
		    font-size: 14px;
		    color: #999999;
		    margin-bottom: 5px;
		}
		.cou_fig .cou_list .person .message .title .info .text {
		    font-size: 14px;
		    color: #666666;
		}
	}
</style>